import { Box, Button, Container, Grid, makeStyles, Typography } from "@material-ui/core";
import { useEffect, useState } from "react";
import GoogleSheetsService from "../../../services/GoogleSheetsService";
import { Link } from 'react-router-dom';
const Transit = () => {
    const classes = useStyles();
    const [data, setData] = useState([]);
    useEffect(() => {
        const fetchData = async (sheetName) => {
            try {
                const data = await GoogleSheetsService.getData(sheetName, 'A:H');
                setData(data);
            } catch (err) {
            }
        };

        fetchData('transit');
    }, []);

    return (
        <Box>
            <div className={classes.root}>
                <div className={classes.slide}>
                    <img src='https://cf-images.ap-southeast-1.prod.boltdns.net/v1/jit/4095259363001/ee978995-7a18-4ccb-881a-eb2359436dff/main/1280x720/7s541ms/match/image.jpg' className={classes.image} />
                    <Box className={classes.overlay}>
                        <Typography variant="h2" className={classes.title}>
                            Ford Transit Hoàn toàn Mới
                        </Typography>
                        <Typography variant="h4" className={classes.title}>
                            Tới Tương Lai
                        </Typography>
                        <Button variant="contained" className={classes.exploreButton}>
                            Đăng ký lái thử
                        </Button>
                    </Box>
                </div>
            </div>

            <Box className={classes.box3}>
                <img className={classes.image3Web} src="https://www.ford.com.vn/content/dam/ecomm/VN/namepate/transit/overview/transit-premium-design-desktop.webp" />
                <img className={classes.image3Mob} src="https://www.ford.com.vn/content/dam/ecomm/VN/namepate/transit/overview/transit-premium-design-mobile.webp" />
            </Box>
            <Container maxWidth="lg" className={classes.container}>
                <Box>
                    <Typography variant="h1" className={classes.title21} >
                        Nâng tầm công nghệ và tiện nghi
                    </Typography>
                    <Typography variant="h1" className={classes.title22} >
                        Tận hưởng trên mọi hành trình
                    </Typography>
                </Box>
                <Grid container className={classes.gird4}>
                    <Grid item xs={12} md={8} >
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.image4Web} src="https://www.ford.com.vn/content/dam/ecomm/VN/namepate/transit/overview/seamless-connection.webp" />
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4} >
                        <Box className={classes.boxParent4}>
                            <Box className={classes.boxChild4}>
                                <Typography variant="h3" className={classes.typo4} >
                                    Kết nối liền mạch cùng với trang bị màn hình đôi cỡ lớn
                                </Typography>
                                <Box className={classes.box4}>
                                    <Typography variant="h3"  >
                                        12.3”
                                    </Typography>
                                    <Typography variant="h6"  >
                                        Màn hình cảm ứng
                                    </Typography>
                                </Box>
                                <Box className={classes.box4}>
                                    <Typography variant="h3"  >
                                        Apple CarPlay™
                                    </Typography>
                                    <Typography variant="h6"  >
                                        Kết nối không dây
                                    </Typography>
                                </Box>
                                <Box className={classes.box4}>
                                    <Typography variant="h3"  >
                                        Android Auto™
                                    </Typography>
                                    <Typography variant="h6"  >
                                        Kết nối không dây
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </Container>
            <Box className={classes.box3}>
                <img className={classes.image3Web} src="https://www.ford.com.vn/content/dam/ecomm/VN/namepate/transit/overview/transit-interior-desktop.webp" />
                <img className={classes.image3Mob} src="https://www.ford.com.vn/content/dam/ecomm/VN/namepate/transit/overview/transit-interior-mobile.webp" />
            </Box>
            <Container maxWidth="lg" className={classes.container}>
                <Box>
                    <Typography variant="h1" className={classes.title21} >
                        Nội thất cao cấp và rộng rãi
                    </Typography>
                    <Typography variant="h1" className={classes.title22} >
                        luôn thoải mái trên cả hành trình
                    </Typography>
                </Box>
                <Grid container className={classes.gird4}>
                    <Grid item xs={12} md={8} >
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.image4Web} src="https://cf-images.ap-southeast-1.prod.boltdns.net/v1/jit/4095259363001/a0aad1bb-e6b9-4c1f-ba38-8d097b45db5d/main/1280x720/3s541ms/match/image.jpg" />
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4} >
                        <Box className={classes.boxParent4}>
                            <Box className={classes.boxChild4}>
                                <Typography variant="h3" className={classes.typo4}>
                                    Động cơ mạnh mẽ bền bỉ
                                </Typography>
                                <Box className={classes.box4}>
                                    <Typography variant="h3"  >
                                        2.3L Diesel EURO5
                                    </Typography>
                                    <Typography variant="h6"  >
                                        Động cơ
                                    </Typography>
                                </Box>
                                <Box className={classes.box4}>
                                    <Typography variant="h3"  >
                                        171 PS
                                    </Typography>
                                </Box>
                                <Box className={classes.box4}>
                                    <Typography variant="h3"  >
                                        Công suất cực đại
                                    </Typography>
                                </Box>
                                <Box className={classes.box4}>
                                    <Typography variant="h3"  >
                                        ESP, ABS và EBD
                                    </Typography>
                                    <Typography variant="h6"  >
                                        Hệ thống
                                    </Typography>
                                </Box>

                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </Container>

            <Container maxWidth="md" className={classes.container}>
                <Box>
                    <Typography variant="h1" className={classes.title21} >
                        Màu xe Ford Transit
                    </Typography>
                    <Typography variant="h1" className={classes.title22} >
                        Đa đạng lựa chọn cho doanh nghiệp của bạn
                    </Typography>
                </Box>
                <Grid container className={classes.gird4}>
                    <Box height="100%" className={classes.boxImg4}>
                        <img className={classes.image4Web} src="https://www.ford.com.vn/content/dam/ecomm/VN/namepate/transit/overview/vn-transit-color-desktop.webp" />
                    </Box>
                </Grid>
            </Container>
            <Container maxWidth="xl" className={classes.container6}>
                <Box>
                    <Typography variant="h1" className={classes.title22} >
                        Các phiên bản Transit
                    </Typography>
                </Box>
                <Grid container className={classes.gird4}>
                    {data.map((xe, index) => (
                        <Grid item key={index} xs={12} md={3} className={classes.gridDanhSach}>
                            <Box className={classes.box6}>
                                <Box className={classes.box6Image}>
                                    <img className={classes.box6ImageChild} src={xe.anhdanhsach} />
                                </Box>

                                <Box className={classes.box6NoiDung}>
                                    <Typography variant="h4" className={classes.title6} >
                                        {xe.ten}
                                    </Typography>
                                    <Typography variant="h6" className={classes.noiDung6}>
                                        {xe.motangan}
                                    </Typography>
                                </Box>
                                <Box>
                                    <Button variant="contained" className={classes.button6} >
                                        <Link to={`/trucks/transit/compare`} className={classes.link}>
                                            Tìm hiểu thêm
                                        </Link>
                                    </Button>
                                    <Button variant="outlined" href={`/bao-gia/${xe.tenLink}`} className={classes.button61}>
                                        Báo giá
                                    </Button>
                                </Box>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box >
    );
};
export default Transit;

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        maxWidth: '100%', // Đảm bảo slider chiếm hết chiều rộng container
        margin: '0 auto', // Căn giữa slider nếu cần
    },
    image: {
        display: 'block',
        width: '100%',
        height: 'auto',
    },
    overlay: {
        position: 'absolute', // Định vị tuyệt đối
        bottom: theme.spacing(5), // Cách đáy một khoảng
        left: theme.spacing(10), // Cách lề trái một khoảng
        color: 'white', // Màu chữ trắng
        padding: theme.spacing(2),
        zIndex: 1, // Đảm bảo overlay nằm trên ảnh
    },
    title: {
        marginBottom: theme.spacing(1),
    },
    exploreButton: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        '&:hover': {
            backgroundColor: theme.palette.primary.dark,
        },
    },
    container: {
        marginTop: theme.spacing(8),
    },
    title21: {
        fontSize: '3rem', // Kích thước chữ lớn
        fontWeight: 'bold',
        marginBottom: theme.spacing(2), // Khoảng cách dưới tiêu đề
        color: '#066fef !important'
    },
    title22: {
        fontSize: '3rem', // Kích thước chữ lớn
        fontWeight: 'bold',
        marginBottom: theme.spacing(2), // Khoảng cách dưới tiêu đề
        color: '#00095b !important'
    },
    image2Web: {
        width: '100%',
        borderRadius: '10px'
    },
    box3: {
        marginTop: theme.spacing(20),
        [theme.breakpoints.down('md')]: {
            marginTop: theme.spacing(8),
        }
    },
    image3Web: {
        width: '100%',
        [theme.breakpoints.down('md')]: {
            display: 'none'
        }
    },
    image3Mob: {
        width: '100%',
        [theme.breakpoints.up('md')]: {
            display: 'none'
        }
    },
    gird4: {
        marginTop: theme.spacing(10),
        [theme.breakpoints.down('md')]: {
            marginTop: theme.spacing(4),
        },
        display: 'flex', // Sử dụng flexbox cho container của grid
        alignItems: 'stretch',
    },
    boxParent4: {
        backgroundColor: 'rgb(6, 111, 239)',
        borderRadius: '10px',
        display: 'flex',
        flexDirection: 'column',
        height: '100%', // Chiếm toàn bộ chiều cao của grid item
        justifyContent: 'center',
        [theme.breakpoints.down('md')]: {
            marginTop: theme.spacing(2),
        }
    },
    boxChild4: {
        padding: theme.spacing(4)
    },
    box4: {
        marginTop: theme.spacing(4),
        color: '#fff'
    },
    typo4: {
        color: '#fff'
    },
    boxImg4: {
        borderRadius: '10px',
        overflow: 'hidden',
        [theme.breakpoints.up('md')]: {
            marginRight: theme.spacing(2),
        }
    },
    image4Web: {
        display: 'block',
        width: '100%',
        height: '100%', // Ảnh lấp đầy container
        objectFit: 'cover',  // Đảm bảo ảnh không bị méo
    },
    box6Image: {
        borderRadius: '10px',
        textAlign: 'center',
        '&:hover $box6ImageChild': {
            transform: 'scale(1.1)'
        },
        overflow: 'hidden'
    },
    box6ImageChild: {
        transition: 'transform 0.3s ease-in-out',
        borderRadius: '10px',
    },
    title6: {
        fontWeight: 'bold',
        marginTop: theme.spacing(3),
        [theme.breakpoints.down('md')]: {
            marginTop: theme.spacing(1),
        },
        marginBottom: theme.spacing(2),
        color: '#00095b !important'
    },
    box6NoiDung: {
        [theme.breakpoints.up('md')]: {
            marginLeft: theme.spacing(2),
        },

    },
    noiDung6: {
        fontSize: '1pc',

    },
    button6: {
        backgroundColor: '#1976d2',
        color: '#fff',
        '&:hover': {
            backgroundColor: '#1565c0',
        },
        [theme.breakpoints.up('md')]: {
            marginLeft: theme.spacing(2),
            marginTop: theme.spacing(2),
        },
    },
    button61: {
        borderColor: '#1976d2',
        color: '#1976d2',
        '&:hover': {
            backgroundColor: '#1565c0',
            color: '#fff',
        },
        [theme.breakpoints.up('md')]: {
            marginLeft: theme.spacing(2),
            marginTop: theme.spacing(2),
        },
    },
    box6: {
        [theme.breakpoints.down('md')]: {
            marginBottom: theme.spacing(5),
        },
    },
    container6: {
        marginTop: theme.spacing(10),
    },
    link: {
        textDecoration: 'none !important',
        color: 'inherit !important', // Kế thừa màu từ button
        '&:hover': {
            textDecoration: 'none !important',
            color: 'inherit !important',
        },
        '&:focus': {
            outline: 'none !important',
        },
    }
}));